import React, { useEffect, useState } from "react";
import styles from "../../styles/social/dashboard.module.css";
import DashboardCard from "../Common/DashboardCard";
import { get } from "../../utils/api";
import { fixedPercentage } from "../../utils/common";
import useAuthStore from "../../store/ContextUser";

const Social = ({ currentYear }) => {
  const {selectedCompany}= useAuthStore();
  const [dashboardData, setDashboardData] = useState({
    diversity: null,
    employee: null,
    lostTime: null,
    training: null,
    communityEngament: null,
  });
  console.log("first", currentYear);

  const apiurls = {
    dashboard: `/dashboard/social/overview?baseYear=${
      currentYear ? "baseline" : null
    }?companyId=${selectedCompany?._id}`,
  };

  const fetchData = async () => {
    try {
      const [dashboard] = await Promise.all([get(apiurls.dashboard)]);
      setDashboardData({
        diversity: dashboard?.data?.diversityInclusion,
        employee: dashboard?.data?.employeeTurnOverRate,
        lostTime: dashboard?.data?.lostTimeInquiry,
        training: dashboard?.data?.trainingAndDevlopment,
        communityEngament: dashboard?.data?.communityEngagement,
      });
    } catch (error) {
      console.log("first34", error);
    }
  };

  console.log("dashboard00000", dashboardData);
  useEffect(() => {
    fetchData();
  }, [currentYear,selectedCompany]);

  return (
    <>
      <div className={styles.cards_container_one}>
        <div className={styles.cards_two_inner}>
          <p className={styles.card_heading}>Employee Turnover Rate </p>
          <p className={styles.card_sub_heading}>
            Overall turnover rate, including voluntary and involuntary
            separations.
          </p>
          <p className={styles.card_value_reported}>
            {dashboardData?.employee?.turnOverRate === ""
              ? 0
              : dashboardData?.employee?.turnOverRate}{" "}
            {" %"}
            {!currentYear ? (
              <span className={styles.turnover_percent}>0% YOY </span>
            ) : null}
          </p>
          <p className={styles.card_sub_heading}>
            Breakdown by gender and employee category
          </p>
          <div className={styles.card_one_table}>
            <div>
              <p className={styles.card_sub_heading}>Male</p>
              <p className={styles.card_value_reported}>
                {dashboardData?.employee?.male || 0}%
              </p>
            </div>
            <div>
              <p className={styles.card_sub_heading}>Female</p>
              <p className={styles.card_value_reported}>
                {dashboardData?.employee?.female || 0}%
              </p>
            </div>
            <div>
              <p className={styles.card_sub_heading}>Permanent</p>
              <p className={styles.card_value_reported}>0%</p>
            </div>
            <div>
              <p className={styles.card_sub_heading}>Temporary</p>
              <p className={styles.card_value_reported}>0%</p>
            </div>
          </div>
        </div>
        <div className={styles.cards_container_one_inner}>
          {currentYear ? (
            <DashboardCard
              title={"Community Engagement"}
              subHeading={"CSR Spending"}
              value={`${
                dashboardData?.communityEngament?.value ?? 0
              }% of revenue`}
            />
          ) : (
            <DashboardCard
              title={"Community Engagement"}
              subHeading={"CSR Spending"}
              value={"0% of revenue"}
              change={"increase"}
              changeValue={"0% YOY"}
            />
          )}

          {currentYear ? (
            <DashboardCard
              title={"Training and Development"}
              subHeading={"Average Training Hours per Employee."}
              value={`${
                dashboardData?.training?.averageTrainingHoursPerEmployee || 0
              } hours/employee`}
            />
          ) : (
            <DashboardCard
              title={"Training and Development"}
              subHeading={"Average Training Hours per Employee."}
              value={`${dashboardData?.training?.averageTrainingHoursPerEmployee} hours/employee`}
              changeValue={`${
                dashboardData?.training?.participationRateChange ?? 0
              }% YOY`}
              change={
                (dashboardData?.training?.participationRateChange ?? 0) > 0
                  ? "increase"
                  : "decrease"
              }
            />
          )}
        </div>
      </div>
      <div className={styles.cards_container_two}>
        <DashboardCard
          title={"Employee Turnover Rate "}
          subHeading={"Lost Time Injury Frequency Rate (LTIFR)"}
          value={dashboardData?.lostTime?.lostTimeIncidents ?? 0}
          subHeading1={"Injury Rate (per 100 employees)"}
          subvalue={
            parseInt(dashboardData?.lostTime?.lostTimePer100Employees) ?? 0
          }
          subchangeValue={`${fixedPercentage(
            dashboardData?.lostTime?.percentageChange || 0
          )}%`}
          subchange={
            dashboardData?.lostTime?.percentageChange > 0
              ? "increase"
              : "decrease"
          }
        />
        <div className={styles.cards_two_inner}>
          <p className={styles.card_heading}>Diversity and Inclusion</p>
          <p className={styles.card_sub_heading}>
            Minority Representation:
            <span className={styles.minority_representation}>
              Workforce :{" "}
              {currentYear
                ? dashboardData?.diversity?.minorityRepresen ?? 0
                : dashboardData?.diversity?.minorityRepresentationCurrent ??
                  0}{" "}
              {" %"}
            </span>
          </p>
          <p className={styles.card_sub_heading}>
            Gender Diversity:
            <span className={styles.turnover_percent}>
              {dashboardData?.diversity?.genderDiversity
                ? Number(dashboardData?.diversity?.genderDiversity).toFixed(2)
                : 0}
            </span>
          </p>
          <div className={styles.card_two_table}>
            <div>
              <p className={styles.card_sub_heading}>Workforce</p>
              <p className={styles.card_value_reported}>
                {dashboardData?.diversity?.workforceWomenPercentage ?? 0}% Women
              </p>
            </div>
            <div>
              <p className={styles.card_sub_heading}>Management</p>
              <p className={styles.card_value_reported}>
                {dashboardData?.diversity?.managementWomenPercentage ?? 0}%
                Women
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Social;
